import React from 'react'

const styles = {
    position: 'fixed',
    bottom: '3%',
    background: '#00000073',
    padding: '10% 8%',
    borderRadius: '20px',
    zIndex: "10000",
    width: '68vw',
    display: 'flex',
    justifyContent: 'center',
    margin: "0% 8%"
}

export default function NotifiicationBox(props) {

  const [hidePreloadSpinner, setHidePreloadSpinner] = React.useState(false);


  React.useEffect(() => {

    if(process.env.REACT_APP_CUSTOM_PRELOADER == 2){
      setHidePreloadSpinner(true);
    }

  },[])


  return (
    <section class="overlay preloadspinner" style={{display: hidePreloadSpinner ? "none": "block" }} >
			<div class="overlay-window-container">
				<div class="overlay-window">
					<div class="overlay-content padding-0">
						<div class="overlay-header">
							<div class="overlay-header-title w-65">
								<h2 style={{color:'#000 !important'}}>Loading Experience ...</h2>
								<p>{props.notificationMessage}</p>
							</div>
							<div class="overlay-header-icon w-35" style={{background: 'none', boxShadow: 'none', marginLeft: '1rem'}}>
								<div class="loader-ring">
                <img src="layout_2/assests/loader.png" />
                </div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
  )
}
{/* <div style={styles}>
        <text>{props.notificationMessage}</text>
    </div> */}

    // Loading is taking more time than usual.  Please wait a moment while we fetch the required data.